import { Button } from "@mui/material";
import appcolors from "../../constants/Colors";
import { t } from "i18next";

const GlobalButton = ({
  variant,
  handleClickBtn,
  endIcon,
  startIcon,
  disabled,
  hoverProperties,
  iconHoverColor,
  btnText,
  disableRipple,
  className,
  styleProps,
}) => {
  return (
    <Button
      disableRipple={false || disableRipple}
      variant={variant || "contained"}
      onClick={handleClickBtn}
      endIcon={endIcon}
      startIcon={startIcon}
      disabled={disabled}
      className={className}
      sx={{
        ...styleProps,
        "&:hover": {
          ...hoverProperties,
        },
        "&.MuiButtonBase-root:hover .MuiButton-startIcon svg": {
          color: iconHoverColor,
        },
        "&.MuiButtonBase-root:hover .MuiButton-endIcon svg": {
          color: iconHoverColor,
        },
      }}
    >
      {t(btnText)}
    </Button>
  );
};

export default GlobalButton;
